import PageHandlersService from '@/utils/page-handlers-service';
import { DEVICE_WIDTH } from '../../../utils/viewport-width';
import axios from 'axios';
import { openDynamicBanner } from '@/components/dynamic-banner';

interface IPromoResponse {
    IsExistCoupon: boolean;
    message: string;
}

const pageHandlers = new PageHandlersService();

const init = () => {
    // Modal
    const promoModal = document.querySelector('.js-p-promo-modal');
    const openModalButton = document.querySelector('.js-p-info-promo');
    const modalForm = document.querySelector<HTMLFormElement>('.js-p-promo-modal-form');
    const modalPromoInput = document.querySelector<HTMLInputElement>('.js-p-promo-modal-form .form-control');

    const handleOpenModal = () => {
        if (promoModal) {
            promoModal.classList.add('active');

            const popupsInteractiveElements = Array.from(
                promoModal.querySelectorAll<HTMLButtonElement | HTMLInputElement>('button, input'),
            );

            popupsInteractiveElements.forEach((element) => {
                element.tabIndex = 0;
            });
        }
    };

    const handleCloseModal = () => {
        if (promoModal) {
            promoModal.classList.remove('active');

            const interactiveElements = Array.from(
                promoModal.querySelectorAll<HTMLButtonElement | HTMLInputElement>('button, input'),
            );

            interactiveElements.forEach((element) => {
                element.tabIndex = -1;
            });
        }
    };

    if (openModalButton && promoModal) {
        const modalCloseElements = document.querySelectorAll('.js-p-promo-modal-close');

        pageHandlers.set(openModalButton, handleOpenModal);

        modalCloseElements.forEach((element) => {
            pageHandlers.set(element, handleCloseModal);
        });
    }

    const handlePromoFormSubmit = async (e: Event) => {
        e.preventDefault();

        if (modalPromoInput?.value) {
            if (modalForm?.action) {
                try {
                    const promoResponse = await axios.post<IPromoResponse>(modalForm.action, {
                        value: modalPromoInput.value,
                    });

                    if (promoResponse.data.IsExistCoupon) {
                        openDynamicBanner(promoResponse.data.message ?? 'Промокод успешно применен', true);
                    } else {
                        openDynamicBanner(promoResponse.data.message ?? 'Промокод не найден', true);
                    }
                } catch (error) {
                    if (axios.isAxiosError(error)) {
                        openDynamicBanner(error.message, true);
                    } else {
                        openDynamicBanner('Промокод не найден', true);
                    }

                    throw error;
                }

                handleCloseModal();
            } else {
                openDynamicBanner('У формы не определен атрибут action', true);
            }
        }
    };

    pageHandlers.set(modalForm, handlePromoFormSubmit, 'submit');

    // Tooltip
    const infoBlockElement = document.querySelector('.js-p-info');

    const tooltipElement = document.querySelector<HTMLElement>('.js-p-info-tooltip-element');
    const tooltipContent = document.querySelector<HTMLElement>('.js-p-info-tooltip-content');

    let isTooltipOpened = false;

    if (tooltipElement && tooltipContent && infoBlockElement) {
        const openTooltip = () => {
            tooltipContent.classList.add('active');

            const tooltipOffset = infoBlockElement.clientWidth - tooltipElement.getBoundingClientRect().left - 17;

            if ((!DEVICE_WIDTH.isMobile && tooltipOffset < 305) || (DEVICE_WIDTH.isMobile && tooltipOffset < 57)) {
                tooltipContent.classList.add('mirrored');
            } else {
                tooltipContent.classList.remove('mirrored');
            }
        };

        const closeTooltip = () => {
            tooltipContent.classList.remove('active');
        };

        if (DEVICE_WIDTH.isDesktop) {
            pageHandlers.set(tooltipElement, openTooltip, 'mouseenter');
            pageHandlers.set(tooltipElement, closeTooltip, 'mouseleave');
        } else {
            const handleTooltipElementClick = (event: Event) => {
                event.stopPropagation();

                if (isTooltipOpened) {
                    closeTooltip();
                } else {
                    openTooltip();
                }

                isTooltipOpened = !isTooltipOpened;
            };

            pageHandlers.set(tooltipElement, handleTooltipElementClick);
            pageHandlers.set(document.body, closeTooltip);
        }
    }
};

const destroy = () => {
    pageHandlers.clear();
};

const _module = { init, destroy };

export default _module;
